import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const addUser = createAsyncThunk(
  "users/addUser",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addUser(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addUserSlice = createSlice({
  name: "addUser",
  initialState,
  reducers: {
    clearAddUserResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(addUser.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addUserList = (state) => state.addUser.value;
export const addLoading = (state) => state.addUser.loading;
export const {clearAddUserResponse} = addUserSlice.actions;

export default addUserSlice.reducer;
